import React from 'react';
import { LegalPage } from '../components/LegalPage';
interface CookiesPageProps {
  language: 'en' | 'es';
}
export function CookiesPage({
  language
}: CookiesPageProps) {
  const content = {
    en: {
      title: 'COOKIE POLICY',
      sections: [{
        heading: 'WHAT ARE COOKIES?',
        paragraphs: ['Cookies are small text files stored on your device when you visit our website. They help us improve your experience.']
      }, {
        heading: 'COOKIES WE USE',
        paragraphs: ['Essential Cookies: Required for the website to function. Cannot be disabled.', 'Analytics Cookies: Help us understand how visitors use our site. Can be disabled.', 'Preference Cookies: Remember your language preference (English/Spanish). Can be disabled.']
      }, {
        heading: 'HOW TO CONTROL COOKIES',
        paragraphs: ['Chrome: Settings › Privacy › Cookies', 'Safari: Settings › Privacy', 'Firefox: Options › Privacy', 'Note: Disabling cookies may affect functionality.']
      }, {
        heading: 'CONTACT',
        paragraphs: ['blackstonerentals.99@gmail.com', '432-528-7892 | 432-803-4737']
      }]
    },
    es: {
      title: 'POLÍTICA DE COOKIES',
      sections: [{
        heading: '¿QUÉ SON LAS COOKIES?',
        paragraphs: ['Las cookies son pequeños archivos de texto almacenados en su dispositivo al visitar nuestro sitio web.']
      }, {
        heading: 'COOKIES QUE USAMOS',
        paragraphs: ['Cookies Esenciales: Necesarias para el funcionamiento del sitio. No se pueden desactivar.', 'Cookies de Análisis: Nos ayudan a entender cómo los visitantes usan el sitio.', 'Cookies de Preferencias: Recuerdan su preferencia de idioma (inglés/español).']
      }, {
        heading: 'CÓMO CONTROLAR LAS COOKIES',
        paragraphs: ['Chrome: Configuración › Privacidad › Cookies', 'Safari: Configuración › Privacidad', 'Firefox: Opciones › Privacidad', 'Nota: Desactivar cookies puede afectar el sitio.']
      }, {
        heading: 'CONTACTO',
        paragraphs: ['blackstonerentals.99@gmail.com', '432-528-7892 | 432-803-4737']
      }]
    }
  };
  const t = content[language];
  return <LegalPage language={language} title={t.title} lastUpdated="January 1, 2026" sections={t.sections} data-id="element-408" />;
}